<template>
  <div class="plantform-live">
    <iframe
      width="100%"
      height="100%"
      :src="roomRul"
      allowfullscreen="true"
      scrolling="no"
      name="studyLive"
      allow="camera *; microphone *; autoplay *; midi *; encrypted-media *;"
      frameborder="0"
      ref="liveFrame"
    ></iframe>
  </div>
</template>

<script>
import {getEnterLiveUrlApi, getBackLiveUrlApi } from '@/api/plantform/task';
import {$Cookies} from '@/utils';
export default {
  name: 'PlantformLive',
  data() {
    return {
      uid: Number($Cookies.get('uid')),
      liveId: null,
      liveType: 'live', // live: 直播；playback: 直播回放
      roomRul: ''
    }
  },
  created() {
    const { type, liveId, roomUrl } = this.$route.query
    if (type) {
      this.liveType = type;
      if (type === 'live') this._getLiveUrl(liveId)
      if (type === 'playback') {
        if (liveId) this._getPlayBackUrl(liveId)
        else this.$message.error('查看直播回放错误')
      }
      if (type === 'createLive') {
        this.watchLive(roomUrl);
      }
    } else {
      this.$message.error('发生错误， 请重新打开页面')
    }
  },
  methods: {
    // 获取直播回放地址
    _getPlayBackUrl(val) {
      //todo 获取 直播回放 地址
      const params = {
        uid: this.uid,
        liveId: Number(val)
      }
      getBackLiveUrlApi(params).then(data => {
        if (data.success) {
          if (data.result.https_playpath_mp4) {
            this.roomRul = data.result.https_playpath_mp4
          } else {
            this.$message.warning('暂无回放地址')
          }
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },
    // 获取在线直播地址
    _getLiveUrl(val) {
      //todo 获取在线直播地址
      const params = {
        uid: this.uid,
        liveId: Number(val)
      }
      getEnterLiveUrlApi(params).then(data => {
        if (data.success) {
          if(data.result.roomUrl) {
            this.roomRul = data.result.roomUrl
          } else {
            this.$message.warning('暂无直播地址')
          }
        } else {
          this.$message.error(data.errorMsg);
        }
      })
    },

    //地址栏获取地址
    watchLive(url) {
      this.roomRul = url;
    }
  }
}
</script>
